import { render, staticRenderFns } from "./VTwitchIcon.vue?vue&type=template&id=ad7e4976&scoped=true"
import script from "./VTwitchIcon.vue?vue&type=script&lang=js"
export * from "./VTwitchIcon.vue?vue&type=script&lang=js"
import style0 from "./VTwitchIcon.vue?vue&type=style&index=0&id=ad7e4976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7e4976",
  null
  
)

export default component.exports